const apiURL = process.env.CI === 'true' ? 'http://localhost' : process.env.NEXT_PUBLIC_API_URL
if (!apiURL) throw new Error('API_URL env variable is missing')

/** The base remote API URL */
export const baseRemoteAPIURL = apiURL

/** The base local API URL */
export const baseLocalAPIURL = '/api'